import { GenericTableColumn } from "@ui-components/Table/GenericTable";

export interface Outages {
	eventId: string;
    date: string;
	description: string;
	outageDuration: number;
}

export interface Maintenance {
	eventId: string;
    date: string;
	description: string;
	outageDuration: number;
}

export const outagesColumns: GenericTableColumn<Outages>[] = [
    {
        header: "Date",
        accessor: "date",
    },
    {
        header: "Description",
        accessor: "description",
    },
    {
        header: "Duration",
        accessor: "outageDuration",
    }
];

export const maintenanceColumns: GenericTableColumn<Maintenance>[] = [
    {
        header: "Date",
        accessor: "date",
    },
    {
        header: "Maintenance Type",
        accessor: "description",
    },
    {
        header: "Duration",
        accessor: "outageDuration",
    }
];
